<template>
  <div class="venue-Detail">
    <div class="header">
      <span class="name">维修项目: </span>
      <span class="value">{{detailInfo.RepairName}}</span>
      <span class="state">
        <span v-if="detailInfo.State === 1" style="color:#f90;">（待审批）</span>
        <span v-if="detailInfo.State === 2" style="color:#ccc;">（已撤销）</span>
        <span v-if="detailInfo.State === 3" style="color:#f05a4a;">（已拒绝）</span>
        <span v-if="detailInfo.State === 4" style="color:#5cadff;">（维修中）</span>
        <span v-if="detailInfo.State === 5" style="color:#19be6b;">（已完成）</span>
      </span>
    </div>
    <p class="line-info">申请人：{{detailInfo.FullName}}</p>
    <p class="line-info">时间：{{detailInfo.ModifiedByDate}}</p>
    <p class="line-info">区域：{{detailInfo.Area}}</p>
    <p class="line-info">备注：{{detailInfo.Remarks}}</p>
    <div class="btn-line" v-if="detailInfo.State === 1">
      <van-button type="primary" style="margin-left: 40px"
                  @click="audite(3)">拒绝
      </van-button>
      <van-button type="primary" style="margin-left: 40px"
                  @click="audite(4)">通过
      </van-button>
    </div>
    <div class="btn-line" v-if="detailInfo.State === 4">
      <van-button type="primary" style="margin-left: 40px"
                  @click="audite(5)">维修完成
      </van-button>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'RepairReportDetail',
    data() {
      return {
        detailInfo: '',
      }
    },
    created() {
      this.detailInfo = JSON.parse(this.$route.query.info)
    },
    methods: {
      async audite(state) {
        let res = await this.xyapi.post(this.$store.state.apiPath + '/api/ExamineRepair/SetSate?id=' + this.detailInfo.RepairID +'&state='+ state)
        if (res.success) {
          this.xy.msgSuc('审批成功')
          this.$router.back()
        }
      },
    }
  }
</script>
<style lang="less" scoped>
  .venue-Detail {
    background: #ffffff;
    padding: 20px 20px 40px;
    font-size: 28px;
    .header {
      .value {
        font-size: 32px;
        font-weight: bold;
      }
    }
    .btn-line {
      margin-top: 50px;
      display: flex;
      justify-content: center;
    }
    .line-info {
      margin-top: 50px;
      font-size: 28px;
    }
  }
</style>
